import React, { useState, useEffect } from "react"
import SingleProductSwiper from "./SingleProductSwiper"
import {
  NiitlegShinjFloor,
  HemjeeFloor,
  HeightFloor,
  AchaalalFloor,
} from "../graphql/RaisedFloorSmallQueries"
import { Hemjee, NiitlegShinj } from "../graphql/SidingSmallQueries"
import { HuldaasNiitlegShinj } from "../graphql/HuldaasSmallQueries"
import { Link } from "gatsby"
import { HiLink } from "react-icons/hi"
import { useTranslation } from "react-i18next"
import {
  NameText,
  YndsenShinjText,
  TypeText,
  ColorText,
  CountryText,
  BrandText,
  TailbarText,
  GoToText,
  OntslohText,
} from "../graphql/QueryById"

const FloorProductIntroduction = ({ data, single, isSiding }) => {
  const {
    table,
    name,
    image,
    productType,
    slug,
    ontslog,
    type,
    md,
    size,
    height,
    achaalal,
    newProduct,
    ontslohBaraa,
    brand,
    country,
    color,
  } = data ?? undefined

  const { i18n } = useTranslation()
  const currentLanguage = i18n.language

  const tableName = table.toLowerCase()
  const isHuldaas = tableName === "huldaas"
  // console.log('Page context is', pageContext)
  // console.log(isSiding)
  // console.log(data.color)
  // const page = pageContext?.page ?? undefined
  // const isSiding = page === "siding"

  const capitalizedName = name.charAt(0).toUpperCase() + name.slice(1)

  const [zoom, setZoom] = useState(false)
  const [zoomImage, setZoomImage] = useState(null)
  const niitleg = isSiding
    ? NiitlegShinj()
    : isHuldaas
    ? HuldaasNiitlegShinj()
    : NiitlegShinjFloor()
  const hemjee = isSiding ? Hemjee() : HemjeeFloor()

  const swiper = (
    <SingleProductSwiper
      images={image}
      setZoomImage={setZoomImage}
      setZoom={setZoom}
      zoom={zoom}
    />
  )

 

  return (
    <div className="flex flex-col mx-auto md:flex-row">
      <div className="relative py-4 md:py-10 md:w-96">{image && swiper}</div>
      <div className="relative flex-1 mx-auto">
        {/* zoom image */}
        {image && (
          <div
            className={`absolute inset-0 object-contain overflow-hidden z-10 bg-gray-50   -ml-2 shadow-lg -sm:mr-2 xl:-mr-24 select-none ${
              zoom ? "hidden md:flex" : "hidden"
            } `}
          >
            {zoomImage}
          </div>
        )}

        {/* Үндсэн мэдээлэл хэсэг */}
        <div className="my-2 md:my-10">
          {/* // ################### Imported from Single Product START const */}
          <div className="max-w-xl divide-y ">
            <div className="grid grid-cols-4">
              <div className="flex items-center justify-end px-2 text-right bg-gray-50">
                {NameText()}
              </div>
              <div className="flex items-center object-contain grid-cols-1 col-span-3 gap-2 py-2 pl-4 pr-2 font-semibold">
                {capitalizedName}
              </div>
            </div>
            <div className="grid grid-cols-4 ">
              <div className="flex items-center justify-end px-2 text-right bg-gray-50">
                {YndsenShinjText()}
              </div>
              <div className="relative flex flex-wrap items-center object-contain col-span-3 gap-1 py-1 pl-4">
                {niitleg.map((item, index) => (
                  <div key={index} className="flex group">
                    <div className="flex w-8 h-full m-1 mx-1 transform group-hover:scale-125">
                      {item.icon}
                    </div>
                    {item.name && (
                      <div className="absolute inset-x-0 z-20 justify-center hidden w-full px-4 py-2 leading-tight text-center text-white bg-gray-500 border rounded-lg shadow-lg -top-9 group-hover:flex bg-opacity-95">
                        {item.name}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            {ontslog && (
              <div className="grid grid-cols-4 ">
                <div className="flex items-center justify-end px-2 text-right bg-gray-50">
                  {OntslohText()}
                </div>
                <div className="relative grid items-center object-contain h-12 grid-cols-6 col-span-3 gap-2 py-1 pl-4">
                  {ontslog.map((item, index) => (
                    <div key={index} className="inline-flex group">
                      <div className="inline-flex w-8 h-full transform group-hover:scale-125">
                        {item.icon}
                      </div>
                      {item.name && (
                        <div className="absolute inset-x-0 z-20 justify-center hidden w-full px-4 py-2 leading-tight text-center text-white bg-gray-500 border rounded-lg shadow-lg -top-9 group-hover:flex bg-opacity-95">
                          {item.name}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {type && (
              <div className="grid grid-cols-4 ">
                <div className="flex items-center justify-end px-2 text-right bg-gray-50">
                  {TypeText()}
                </div>
                <div className="relative grid items-center object-contain h-12 grid-cols-6 col-span-3 gap-2 py-1 pl-4">
                  {type.map((item, index) => (
                    <div key={index} className="inline-flex group">
                      <div className="inline-flex w-8 h-full transform group-hover:scale-125">
                        {item.icon}
                      </div>
                      {item.name && (
                        <div className="absolute inset-x-0 z-20 justify-center hidden w-full px-4 py-2 leading-tight text-center text-white bg-gray-500 border rounded-lg shadow-lg -top-9 group-hover:flex bg-opacity-95">
                          {item.name}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {color && (
              <div className="grid grid-cols-4 ">
                <div className="flex items-center justify-end px-2 text-right bg-gray-50">
                  {ColorText()}
                </div>
                <div className="relative flex items-center object-contain h-12 col-span-3 gap-2 py-1 pl-4">
                  {color.map((item, index) => (
                    <div key={index} className="relative inline-flex group">
                      <div
                        className="inline-flex w-10 h-10 border rounded-full group-hover:border-2 group-hover:border-brand-darker"
                        style={{ backgroundColor: item.hex }}
                      ></div>
                      <div
                        className="absolute left-0 z-10 items-center hidden p-20 leading-tight text-gray-800 border rounded-full shadow-lg group-hover:flex group-focus:flex -top-36"
                        style={{ backgroundColor: item.hex }}
                      >
                        {item.name && (
                          <div
                            className={`absolute inset-0 z-20 items-center justify-center hidden leading-tight rounded-full group-hover:flex group-focus:flex ${
                              item.genColor === "Бараандуу"
                                ? "text-white"
                                : "text-gray-800"
                            }`}
                          >
                            {item.name}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {country && (
              <div className="grid grid-cols-4 group">
                <div className="flex items-center justify-end px-2 text-right bg-gray-50">
                  {CountryText()}
                </div>
                <div className="grid items-center object-contain h-12 grid-cols-6 col-span-3 gap-2 py-1 pl-4">
                  <div className="relative inline-flex group">
                    <div className="inline-flex w-full h-8 transform shadow group-hover:scale-125 opacity-70 group-hover:opacity-100 group-hover:hidden">
                      {country[0].flag}
                    </div>
                    <div className="hidden py-2 font-bold group-hover:flex">
                      {country[0].name}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {brand && (
              <div className="grid grid-cols-4 group">
                <div className="flex items-center justify-end px-2 text-right bg-gray-50">
                  {BrandText()}
                </div>
                <div className="relative flex items-center object-contain h-12 col-span-3 gap-1 py-1 pl-4 group">
                  {brand[0].logo ? (
                    <div className="relative inline-flex object-contain w-10 h-full group-hover:opacity-100 group-hover:hidden">
                      {brand[0].logo}
                    </div>
                  ) : (
                    <div className="inline-flex">{brand[0].name}</div>
                  )}
                  {brand[0].logo && (
                    <div className="hidden py-2 font-bold group-hover:flex">
                      {brand[0].name}
                    </div>
                  )}
                </div>
              </div>
            )}

            {md && (
              <div className="grid grid-cols-4 ">
                <div className="flex items-center justify-end px-2 text-right bg-gray-50">
                  {TailbarText()}
                </div>
                <div className="grid items-center object-contain col-span-3 gap-2 py-1 pl-4 pr-2 min-h-12">
                  <div className="relative inline-flex text-sm group">{md}</div>
                </div>
              </div>
            )}
            {size && (
              <div className="grid grid-cols-4 group">
                <div className="flex items-center justify-end px-2 space-x-2 text-right bg-gray-50 ">
                  <div className="hidden group-hover:flex">{hemjee.name}</div>
                  <span className="w-8 h-8 opacity-70 group-hover:hidden">
                    {hemjee.icon}
                  </span>
                </div>
                <div className="flex items-center object-contain col-span-3 gap-1 py-1 pl-4 min-h-12">
                  <div className="relative inline-flex group">{size}</div>
                  <div>({hemjee.unit})</div>
                </div>
              </div>
            )}
            {achaalal && (
              <div className="grid grid-cols-4 group">
                <div className="flex items-center justify-end px-2 space-x-2 text-right bg-gray-50 ">
                  <div className="hidden group-hover:flex">
                    {AchaalalFloor().name}
                  </div>
                  <span className="w-8 h-8 opacity-70 group-hover:hidden">
                    {AchaalalFloor().icon}
                  </span>
                </div>
                <div className="flex items-center object-contain col-span-3 gap-1 py-1 pl-4 min-h-12">
                  <div className="relative inline-flex group">{achaalal}</div>
                  <div>{AchaalalFloor().unit}</div>
                </div>
              </div>
            )}
            {height && (
              <div className="grid grid-cols-4 group">
                <div className="flex items-center justify-end px-2 space-x-2 text-right bg-gray-50 ">
                  <div className="hidden group-hover:flex">
                    {HeightFloor().name}
                  </div>
                  <span className="w-8 h-8 opacity-70 group-hover:hidden">
                    {HeightFloor().icon}
                  </span>
                </div>
                <div className="flex items-center object-contain col-span-3 gap-1 py-1 pl-4 min-h-12">
                  <div className="relative inline-flex group">{height}</div>
                  <div>{HeightFloor().unit}</div>
                </div>
              </div>
            )}
          </div>

          {!single && (
            <Link
              to={`/${isSiding ? "siding" : "raised-floor"}/${slug}`}
              className="flex items-center justify-center my-10 space-x-2 text-gray-500 hover:underline hover:text-gray-900"
            >
              <HiLink />
              <div>{GoToText()}</div>
            </Link>
          )}
          {/* // ################### Imported from Single Product END */}
        </div>
      </div>
    </div>
  )
}

export default FloorProductIntroduction
